<script setup>
import axios from "axios";
import { debounce } from 'lodash';
import { ref, watch, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
const store = useStore();
const router = useRouter();
const keyword = computed(() => store.getters.getKeyword);
const productId = computed(() => store.getters.getProductId);
const list = ref([]);
const doSearch = (keyword) => {
  if (keyword) {
    axios.get('/question/search', {params: { productId: productId.value, keyword }}).then(res => {
      if (res.data && res.data.content) {
        const regex = new RegExp(`(${keyword})`, 'gi');
        res.data.content.forEach(item => {
          item.highlightedContent = item.content.replace(regex, '<span style="color: rgba(75, 106, 255, 1)">$1</span>');
        });
        list.value = res.data.content;
        console.log('search result', res.data);
      } else {
        console.error('Invalid response data:', res.data);
      }
    }).catch(err => {
      console.log(err);
    });
  }
}
onMounted(() => {
  doSearch(keyword.value);
});
// 防抖函数，延迟500毫秒执行
const debouncedSearch = debounce((keyword) => {
  doSearch(keyword);
}, 500);

watch(() => keyword.value, (newValue) => {
  debouncedSearch(newValue);
});
const goToDetail = (item) => {
  router.push({
    path: '/detail',
    query: item,
  });
};
const goToFeedback = (item) => {
  router.push({
    path: '/feedback',
  });
};
</script>

<template>
  <div class="feedback-container" v-if="list.length > 0">
    <ul class="content-box">
      <li v-for="item in list">
        <a v-on:click="goToDetail(item)" v-html="item.highlightedContent"></a>
      </li>
    </ul>
    <div class="feedback">
      <p class="wording">没有找到想要的问题？</p>
      <div><button class="feedback-button-small" @click="goToFeedback">我要反馈</button></div>
    </div>
  </div>
  <div class="no-result" v-else>
    <div class="image-container">
      <img src="../assets/no-result.png" alt="No Result" class="no-result-image">
      <span class="image-text">未找到相关问题</span>
    </div>
    <button class="feedback-button" @click="goToFeedback">我要反馈</button>
  </div>
</template>

<style scoped lang="scss">
@import '~/entries/index/index.scss';
.feedback-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;

}
.content-box {
  padding: 0 30 * $px;
  margin-block-start: 10 * $px;
  margin-block-end: 10 * $px;

  li {
    list-style-type: none;
    height: 90 * $px;
    font-size: 28 * $px;
    line-height: 90 * $px;
    border-bottom: 1px solid rgba(227, 227, 227, 1);
    padding-left: 80 * $px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &::before {
      content: '';
      position: absolute;
      left: 30 * $px;
      top: 50%;
      transform: translateY(-50%);
      width: 26 * $px;
      height: 26 * $px;
      background-image: url('../assets/search2.png');
      background-size: cover;
    }
    &:last-child {
      border-bottom: none; // 移除最后一个li的底部边框
    }
  }
}
.feedback {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  background: rgba(245, 248, 253, 1);
  .wording {
    font-size: 24*$px;
    line-height: 33.6*$px;
    color: rgba(136, 136, 136, 1);
    margin-block-start: 30*$px;
    margin-block-end: 0;
  }
}
.no-result {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .image-container {
    position: relative;
    display: inline-block;
    .no-result-image {
      width: 301 * $px;
      height: 301 * $px;
    }
    .image-text {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      font-size: 24*$px;
      line-height: 33.6*$px;
      color: rgba(136, 136, 136, 1);
      white-space: nowrap;
    }
  }
}

.feedback-button {
  margin: 30 * $px 0;
  width: 217 * $px;
  height: 79 * $px;
  background: rgba(231, 235, 255, 1);
  border: none;
  border-radius: 45 * $px;
  font-size: 28 * $px;
  color: rgba(75, 106, 255, 1);
}
.feedback-button-small {
  margin-top: 30 * $px; /* 按钮与图片之间的间距 */
  width: 169 * $px;
  height: 66 * $px;
  background: rgba(231, 235, 255, 1);
  border: none;
  border-radius: 36 * $px;
  font-size: 24 * $px;
  line-height: 33.6 * $px;
  color: rgba(75, 106, 255, 1);
}
</style>
